import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.support.apply');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-support-apply',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.support.apply/view.scss */
:host {
  display: block;
  min-height: 100vh;
  background: #f5f7fb;
}`],
})
export class PageSupportApplyComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public token: string = '';
    public loading: boolean = true;
    public error: string = '';
    public submitted: boolean = false;
    public program: any = null;
    public form: any = {
        company_name: '', registed_number: '', ceo_name: '',
        ceo_email: '', ceo_phone: '',
        business_area: '', employee_count: 0, revenue: 0,
        requested_amount: 0, summary: ''
    };

    public async ngOnInit() {
        await this.service.init();
        // 공개 초대 페이지: 인증 체크 없이 전역 로딩 오버레이를 즉시 해제
        await this.service.loading.hide();
        try {
            this.token = WizRoute.segment.token || '';
            if (!this.token) {
                this.error = '유효하지 않은 링크입니다.';
                return;
            }
            const { code, data } = await wiz.call('verify', { token: this.token });
            if (code != 200) {
                this.error = data?.message || '초대 링크를 확인할 수 없습니다.';
                return;
            }
            const app = data.data.application;
            this.program = data.data.program;
            // 기존 입력값으로 폼 채움
            for (const k of Object.keys(this.form)) {
                if (app[k] != null && app[k] !== '') this.form[k] = app[k];
            }
            if (app.invite_status === 'submitted') {
                this.submitted = true;
            }
        } catch (e: any) {
            this.error = e?.message || '초대 링크를 확인할 수 없습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async submit() {
        if (!this.form.company_name) {
            this.service.alert.show({ title: '입력 오류', message: '기업명을 입력하세요.', action: '확인' });
            return;
        }
        if (!this.form.ceo_name || !this.form.ceo_email) {
            this.service.alert.show({ title: '입력 오류', message: '담당자명과 이메일을 입력하세요.', action: '확인' });
            return;
        }
        const payload = { ...this.form };
        payload.employee_count = Number(payload.employee_count) || 0;
        payload.revenue = Number(payload.revenue) || 0;
        payload.requested_amount = Number(payload.requested_amount) || 0;
        const { code, data } = await wiz.call('submit', {
            token: this.token, data: JSON.stringify(payload)
        });
        if (code != 200) {
            this.service.alert.show({ title: '제출 실패', message: data?.message || '오류', action: '확인' });
            return;
        }
        this.submitted = true;
        await this.service.render();
    }
}

export default PageSupportApplyComponent;